import type { SSMClientConfig } from "@aws-sdk/client-ssm";
import { SSMClient, GetParameterCommand } from "@aws-sdk/client-ssm";
import crypto from "crypto";

import { isServer } from "./browser-utils";
import { publicRuntimeConfig } from "util/env-utils";

/**
 * @summary - Get a secret from AWS parameter store. Needs AWS authentication.
 * @async
 *
 * @param Name - Name of the parameter to fetch
 * @param WithDecryption - See aws-sdk docs
 */
async function getSecret(Name: string, WithDecryption = true): Promise<string> {
    const clientConfig: { credentials?: SSMClientConfig["credentials"] } = {};

    if (isServer()) {
        const { fromNodeProviderChain } = await import(
            "@aws-sdk/credential-providers"
        );
        clientConfig.credentials = fromNodeProviderChain({
            maxRetries: 5,
            timeout: 10000
        });
    }

    const ssmClient = new SSMClient({
        ...clientConfig,
        region: publicRuntimeConfig.AWS_REGION
    });
    const command = new GetParameterCommand({
        Name,
        WithDecryption
    });
    const {
        Parameter: { Value }
    } = await ssmClient.send(command).catch((error) => {
        console.log(`Failed to get secret`, Name);

        throw error;
    });

    ssmClient.destroy();

    return Value;
}

/**
 * @summary - Get Intercom secret from parameter store
 * @async
 */
export const getIntercomSecret = async (identity: string) => {
    const secret = await getSecret(`/intercom/identity/secret`);
    const intercomHash = crypto
        .createHmac(`sha256`, secret)
        .update(identity)
        .digest(`hex`);

    return intercomHash;
};

/**
 * @summary - Get Unleash Access Token
 * @async
 */
export const getUnleashSecret = async (): Promise<string> =>
    getSecret(`/unleash/shared/secret`);
